/**
 * Lazy loading workaround for Safari and iOS
 *
 * In Safari 15.4 was added lazy-loading support for images with the loading attribute on * the <img> element. It's implementation in some cases does not work in editor.
 *
 * To fix this we've decided to remove loading attribute.
 *
 */

import bowser from 'yola-bowser';

const removeLazyLoadingAttributeFromImages = (element) => {
  if (!bowser.ios && !bowser.safari) return;
  const images = element.querySelectorAll('img[loading="lazy"]');
  images.forEach((image) => image.removeAttribute('loading'));
};

export default removeLazyLoadingAttributeFromImages;
